import { ensurePlayerSession } from "@/auth/ensurePlayerSession";
import type { PlayerOwner } from "@/features/payment/types";
import { isSupabaseConfigured } from "@/integrations/supabase/supabaseConfig";
import { createPlayerProfileRepository } from "@/player/playerProfileRepository";

interface ResolvePlayerOwnerOptions {
  readonly forceLocal?: boolean;
}

const LOCAL_PLAYER_OWNER: PlayerOwner = {
  ownerId: "local-player",
  ownerKind: "local",
};

export async function resolvePlayerOwner(
  options: ResolvePlayerOwnerOptions = {},
): Promise<PlayerOwner> {
  if (options.forceLocal === true || !isSupabaseConfigured()) {
    return LOCAL_PLAYER_OWNER;
  }
  try {
    const { getSupabaseBrowserClient } =
      await import("@/integrations/supabase/supabaseClient");

    const client = getSupabaseBrowserClient();
    const profiles = createPlayerProfileRepository(client);
    const { ownerId, ownerKind } = await ensurePlayerSession({
      client,
      upsertProfile: (input) => profiles.upsert(input),
    });
    return { ownerId, ownerKind };
  } catch (error) {
    console.warn(
      "HoverIdle anonymous sign-in failed; continuing as local player:",
      error,
    );
    return LOCAL_PLAYER_OWNER;
  }
}
